import { Box, useMediaQuery } from '@chakra-ui/react';
import { Centro, Grilla, GrillaEl, Imagen, PilaV } from '../atomos';
import Persona from '@/assets/img/persona_login.png';
import LogoBlanco from '@/assets/icons/new_logotipo_blanco.svg';
import LogoDark from '@/assets/icons/new_logotipo.svg';
import LogoAusenciaSepia from '@/assets/icons/new_logotipo_ausencia_color_sepia.svg';
import LogoAusenciaBlanco from '@/assets/icons/new_logotipo_ausencia_color_blanco.svg';
import LogoFondoOscuro from '@/assets/img/logo_fondo_oscuro.webp';
import LogoFondoClaro from '@/assets/img/logo_fondo_claro.webp';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';
import CargandoPantallaCompleta from './CargandoPantallaCompleta';
import { FACTORING } from '@/routes/AppRoutes';


const PlantillaCredenciales = ({
  imageMap,
  fondoOscuro
}: {
  imageMap?: Record<string, string>;
  fondoOscuro?: Record<string, boolean>;
}) => {
  const [mobile] = useMediaQuery('(max-width: 768px)');
  const location = useLocation();
  const [imageSrc, setImageSrc] = useState<string>(null);
  const [fondoOscuroState, setfondoOscuroState] = useState(false);

  useEffect(() => {
    const decodedPath = decodeURIComponent(location.pathname);
    if (imageMap && imageMap[decodedPath]) {
      setImageSrc(imageMap[decodedPath]);
    } else {
      setImageSrc(Persona);
    }
  }, [location.pathname, imageMap]);

  useEffect(() => {
    const decodedPath = decodeURIComponent(location.pathname);
    if (fondoOscuro && fondoOscuro[decodedPath]) {
      setfondoOscuroState(fondoOscuro[decodedPath]);
    } else {
      setfondoOscuroState(false);
    }
  }, [location.pathname, fondoOscuro]);

  return (
    <Grilla
      templateColumns={mobile ? '1fr' : 'repeat(2 , 1fr)'}
      templateRows={mobile ? '1fr auto' : '1fr'}
      minH={'100dvh'}
      className={fondoOscuroState ? 'new-fondo-marca-dark' : 'new-fondo-marca-light'}
    >
      {!mobile ? (
        <GrillaEl
          colSpan={1}
          borderRightRadius={'3xl'}
          as={PilaV}
          justifyContent={'space-between'}
          alignItems={'flex-start'}
          maxH={'full'}
          overflow={'hidden'}
          pt={4}
          gap={10}
        >
          <Imagen
            src={imageSrc}
            alt='persona-login'
            flexGrow={1}
            h={'full'}
            objectFit={'cover'}
            objectPosition={'top'}
            position={'absolute'}
            bottom={0}
            left={0}
            zIndex={0}
          />
        </GrillaEl>
      ) : (
        <Box position={'absolute'} left={'-87px'} top={'-69px'} h={'380px'} zIndex={2}>
          <Imagen src={fondoOscuroState ? LogoFondoOscuro : LogoFondoClaro} />
        </Box>
      )}

      <GrillaEl
        px={4}
        colSpan={1}
        as={Centro}
        overflowX={'hidden'}
        className={mobile ? (fondoOscuroState ? 'new-fondo-marca-dark' : 'new-fondo-marca-light') : ''}
        position={'relative'}
      >
        {/* Logo arriba derecha */}
        {!mobile && <Box position="absolute" top={10} right={20}>
          <Link to={FACTORING.LANDING}>
            <Imagen h={10} src={fondoOscuroState ? LogoBlanco : LogoDark} alt="logo" />
          </Link>
        </Box>}
        <Suspense fallback={<CargandoPantallaCompleta mobile={mobile} />}>
          <Outlet context={{ fondoOscuro: fondoOscuroState }} />
        </Suspense>
      </GrillaEl>
      {mobile && (
        <Imagen
          src={fondoOscuroState ? LogoAusenciaBlanco : LogoAusenciaSepia}
          h={'30'}
          justifySelf={'center'}
          mt={8}
          mb={'30px'}
          zIndex={2}
        />
      )}
    </Grilla>
  );
};

export default PlantillaCredenciales;
